module.exports = __webpack_public_path__ + "img/drop.81e8b832.png";